<template>
    <admin-breadcrumbs>
        <li class="breadcrumb-item">
            <router-link to="/admin/series/">
                Series
            </router-link>
        </li>

        <li class="breadcrumb-item active">
            Create
        </li>
    </admin-breadcrumbs>

    <div class="card card-default">

        <div class="card-header">
            Create Lesson
        </div>

        <div class="card-body">

            <lesson-create-form
                endpoint="/admin/api/lessons"
                method="post"
                :data="{'series_id': $route.query.series_id}"
            />

        </div>
    </div>
</template>

<script>
import AdminBreadcrumbs from "../../../partials/AdminBreadcrumbs.vue";
import LessonCreateForm from "../../../admin/LessonCreateForm.vue";

export default {
    name: "LessonCreate",

    components: {
        LessonCreateForm,
        AdminBreadcrumbs,
    },
};
</script>
